import React from "react";
import ReactDOM from "react-dom/client";

// Font self-hosted (niente CDN Google Fonts: brand garantito + GDPR-safe).
// Famiglie registrate con i nomi standard "Manrope" / "Inter" / "JetBrains Mono"
// usati in index.css e tailwind.config.js.
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";

import "@/index.css";
import App from "@/App";

// =============================================================================
// PATCH: Suppress ResizeObserver loop error completely
// This is a known non-critical error in Radix UI/shadcn dropdown components
// =============================================================================

// 1. Patch ResizeObserver to ignore the error at source
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch updates and prevent loop errors
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver callback errors
        }
      });
    });
  }
};

// 2. Suppress error events
const resizeObserverErrHandler = (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop') ||
    e.message.includes('ResizeObserver loop completed with undelivered notifications')
  )) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
};
window.addEventListener('error', resizeObserverErrHandler);

// 3. Suppress unhandled rejection for ResizeObserver
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

// 4. Override console.error to filter ResizeObserver messages
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  if (message.includes('ResizeObserver loop')) {
    return; // Suppress
  }
  originalConsoleError.apply(console, args);
};

// =============================================================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
